export default {
  lang: {
    confirm: {
      title:
        'Είστε σίγουροι ότι θέλετε να το διαγράψετε; Δεν μπορείτε να την επαναφέρετε μετά τη διαγραφή',
      okText: 'Διαγραφή',
      cancelText: 'Ακύρωση',
    },
  },
};
